/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

export interface ToastIconProps {
  children: string;
}

// Plain span, not MaterialSymbol. Toasts reuse the same icon instance instead of
// recreating it each render, and MaterialSymbol's MUI styling tries to tweak that
// reused icon on the fly — which React 19 doesn't allow and crashes on.
export const ToastIcon = ({ children }: ToastIconProps) => (
  <span className="material-symbols-outlined" aria-hidden="true">
    {children}
  </span>
);

export default ToastIcon;
